import React from 'react'
import { Table } from 'react-bootstrap'
import ToggleBar from '../../commoncomponents/toggleBar'
import { utcToReportDate } from '../../../utils/dateConvert'
import { rounding } from '../../../utils/math'
import { downloadCSVFile } from '../../../api/apiClient'
import Location from '../../commoncomponents/location';
import ShowIButtonName from '../../commoncomponents/showIButtonName';

function RawMessagesEvents(props) {
  let assetName = props.assetCustomerName;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  let tempAEnabled = props.tempAEnabled;
  let tempBEnabled = props.tempBEnabled;
  let driverIDEnabled = props.driverIDEnabled;

  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>ID</th>
          <th>Recieved</th>
          <th>Created</th>
          <th>Location</th>
          <th>LogID</th>
          <th>Speed</th>
          <th>Odometer</th>
          <th>Trip</th>
          <th>Ignition</th>
          <th>Duress</th>
          <th>Fridge</th>
          {tempAEnabled && <th>Temp A</th>}
          {tempBEnabled && <th>Temp B</th>}
          {driverIDEnabled && <th>Driver ID</th>}
        </tr>
      </thead>
      <tbody>
        {props.reportDetail.map((message, index) => {
          const item = message.rawMessage
          return (
            <tr key={index}>
              <td>{item.id}</td>
              <td>{utcToReportDate(item.received)}</td>
              <td>{utcToReportDate(item.created)}</td>
              <td>
                <Location
                  address={<span><em>A</em>{`${item.gPRMC.latitude},${item.gPRMC.longitude}`}</span>}
                  lat={item.gPRMC.latitude}
                  lng={item.gPRMC.longitude}
                />
              </td>
              <td>{item.messageID}</td>
              <td>{rounding(item.gPRMC.speed)}</td>
              <td>{item.odometer}</td>
              <td>{item.tripCount}</td>
              <td>{item.iO3 == 0 ? "Engine Off" : "Engine On"}</td>
              <td>{item.messageID == 59 ? "Y" : "N"}</td>
              <td>{item.iO1 == 0 ? "Off" : "On"}</td>
              {tempAEnabled && <td>{item.sensorAValue}</td>}
              {tempBEnabled && <td>{item.sensorBValue}</td>}
              {driverIDEnabled && <td>
                  {item.ibutton && 
                  <ShowIButtonName 
                  ibuttonId={message.ibuttonId}
                  serialno={message.serialno} 
                  iButtonName={message.iButtonName}
                />}
                  </td>}
            </tr>
          )

        })}

      </tbody>
    </Table>
  )
  const handleDownloadExcel = () => {
    // alert("clicked")
    downloadCSVFile(props.reportDetail, "RawMsgs", assetName, timeZone);
  }
  return (
    <ToggleBar caption="Raw Messages & Events" download={handleDownloadExcel} openTab="false" icon="fa-database" color="#8a6d3b" content={data} />

  )
}

export default RawMessagesEvents;
